import { render, staticRenderFns } from "./EditTPQuestionForm.vue?vue&type=template&id=377b4cff&scoped=true&"
import script from "./EditTPQuestionForm.vue?vue&type=script&lang=js&"
export * from "./EditTPQuestionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377b4cff",
  null
  
)

export default component.exports